<template>
    <div class="designeroption" data-designer-component-id="numerals">
        <h3>{{title}}</h3>
        <div class="stylesoption">
            <div class="row">
                <div class="col-sm" v-for="index in numeral_range">
                    <designer-question-hardware-numeral :fabricator="fabricator"
                                                        v-model:target="localTarget[index]"
                                                        :slab="slab"
                                                        :type-range="typeRange"
                                                        :hardware-handle="hardwareHandle"
                                                        :hardware-colour="hardwareColour"
                                                        :hardware-suite="hardwareSuite"
                                                        :numeral-colour="numeralColour"
                                                        :title="'Numeral ' + (index + 1)"></designer-question-hardware-numeral>
                </div>
            </div>
            <div v-if="extra_text" class="mt-3">
              {{ extra_text }}
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {

        emits: ['update:target'],
        computed: {
            localTarget: {
                get(){
                    return this.target;
                },
                set(new_val){
                    this.$emit('update:target', new_val);
                }
            },
            numeral_range(){
//                var end = this.target.findIndex(function (el) {
//                    return el === null;
//                });
//
//                if (end < 0){
                    return window._.range(this.localTarget.length);
//                }
//
//                return _.range(end + 1);
            }
        },
        props: {
            target: {
                required: true,
                type: Array,
                validator(value) {
                    return value.length === 4;
                },
                default(){
                    return [null, null, null, null];
                }
            },
            title: {
                default(){
                    return 'Numerals';
                }
            },
            hardwareColour: {
                required: true
            },
            numeralColour: {
                required: false,
                default(){
                    return 0;
                }
            },
            slab: {
                required: true
            },
            hardwareHandle: {
                required: true
            },
            fabricator: {
                required: true
            },
            hardwareSuite: {
                required: false,
                default(){
                    return '';
                }
            },
            typeRange: {
                required: false,
                default(){
                    return '';
                }
            },
            extra_text: {
              default(){
                return false;
              }
            },
        },
    }
</script>
